import React, { useState } from 'react'

import useToast from '../../../../hooks/useToast'
import { ButtonRound } from '../../../../components/Header/styles'
import Popup from 'reactjs-popup'
import { Container, Title } from './styles'
import { FaUsers } from 'react-icons/fa6'
import UsersSearch from '../FileDetails/GroupsSearch'

interface ModalUserPermissionProps {
  onSubmitButton: () => void
  fileRefs: any
}

const UserPerMission: React.FunctionComponent<ModalUserPermissionProps> = ({
  onSubmitButton,
  fileRefs,
}) => {
  const [documentId, setDocumentId] = useState<any>([])
  const toast = useToast()

  const onPressUsersPermission = () => {
    let ids: any = []

    fileRefs.current.map((ref: any) => {
      if (ref?.current?.checked) {
        ids.push(ref.current._id)
      }
    })
    if (ids.length > 0) {
      setDocumentId(ids)
    } else {
      setDocumentId([])
    }
  }

  return (
    <>
      <div id='portalMenuUsers' />
      <Popup
        trigger={
          <ButtonRound
            data-tooltip-id='my-tooltip'
            data-tooltip-content='Permissões de usuarios'
            data-tooltip-place='top'
          >
            <FaUsers color='white' />
          </ButtonRound>
        }
        onOpen={() => onPressUsersPermission()}
        position='bottom right'
      >
        <Container>
          <Title>{documentId.length} arquivo(s) selecionado</Title>
          {documentId.length && (
            <UsersSearch
              menuPortalTarget={document.querySelector('#portalMenuUsers')}
              menuPosition={'fixed'}
              fileId={documentId}
            />
          )}
        </Container>
      </Popup>
    </>
  )
}

export default UserPerMission
